"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export default function useIsTouchDevice() {
  const $ = _c(2);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof globalThis === "undefined") {
        return;
      }
      const win = globalThis as typeof globalThis & {
        matchMedia?: (query: string) => MediaQueryList;
      };
      const hasFinePointer = win.matchMedia?.("(pointer: fine)")?.matches;
      if (hasFinePointer) {
        setIsTouchDevice(false);
        return;
      }
      const onTouchStart = () => {
        setIsTouchDevice(true);
        globalThis.removeEventListener("touchstart", onTouchStart);
      };
      globalThis.addEventListener("touchstart", onTouchStart, {
        passive: true
      });
      return () => {
        globalThis.removeEventListener("touchstart", onTouchStart);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isTouchDevice;
}